module.exports = __webpack_public_path__ + "static/media/C3.bcdb7354.jpg";